import { ItemType } from 'ui/atoms/Select/types'
import { ContactInformationFormProps } from '../components/LocationDetailsForm/components/ContactInformationForm/types'
import { useMemo } from 'react'
import { Rule } from 'ui/molecules/Form/components/FormItem/types'
import { LOCATION_ADDING_FORM_VALUES } from 'texts/locationDetails'
import { entityWithoutHyphensRegex, locationRegex } from 'constants/regex'

export const useDynamicValidationRules = (
  values: ContactInformationFormProps['values'],
  cities: ItemType[],
  locations: ItemType[]
) =>
  useMemo(() => {
    const createValidationRule = (pattern: RegExp, message: string): Rule => ({
      type: 'pattern',
      value: pattern,
      message,
    })

    const isCityFromDirectory = cities.some(
      (el) => el.label === values.cityName
    )
    const isLocationFromDirectory = locations.some(
      (el) => el.label === values.locationName
    )

    return {
      cityRules: [
        {
          type: 'required',
          message: LOCATION_ADDING_FORM_VALUES.CITY.REQUIRED_MESSAGE,
        },
        {
          type: 'max',
          value: 100,
          message: LOCATION_ADDING_FORM_VALUES.CITY_NAME.MAX_VALIDATION_MESSAGE,
        },
        ...(!isCityFromDirectory
          ? [
              createValidationRule(
                entityWithoutHyphensRegex,
                LOCATION_ADDING_FORM_VALUES.CITY.VALIDATION_MESSAGE
              ),
            ]
          : []),
      ],
      locationRules: [
        {
          type: 'required',
          message: LOCATION_ADDING_FORM_VALUES.LOCATION.REQUIRED_MESSAGE,
        },
        {
          type: 'max',
          value: 100,
          message:
            LOCATION_ADDING_FORM_VALUES.LOCATION_NAME.MAX_VALIDATION_MESSAGE,
        },
        ...(!isLocationFromDirectory
          ? [
              createValidationRule(
                locationRegex,
                LOCATION_ADDING_FORM_VALUES.LOCATION.VALIDATION_MESSAGE
              ),
            ]
          : []),
      ],
    }
  }, [values.cityName, values.locationName, cities, locations])
